import { IFeatureAccountQuery } from 'generated/sanity-graphql';

import { useEmergencyBanner } from '../../emergency-banner/use-emergency-banner';
import { getUniqueComponents } from '../utils';

import { Components } from './types';

export const useFeatureAccountPageComponents = (
  featureAccountPage?: IFeatureAccountQuery['FeatureAccount']
) => {
  const featureAccountPageComponentMap = getUniqueComponents(featureAccountPage?.components ?? []);

  const { emergencyBanner, emergencyBannerLoading } = useEmergencyBanner(
    featureAccountPageComponentMap.EmergencyBanner
  );

  const featureAccountPageComponentsLoading = emergencyBannerLoading;

  const allPopulatedComponents: Components = emergencyBanner
    ? ([emergencyBanner] as Components)
    : [];

  return {
    featureAccountPageComponentsLoading,
    featureAccountPageComponents: allPopulatedComponents,
  };
};
